import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import React, { useEffect, useState } from 'react';
import maestroService from '../maestroService';
import { dispararAcaoSimulada } from '../utils/acaoSimulada';
import { formatarDataHora } from '../utils/formatters';

interface ModalGerenciarModeloProps {
  aberto: boolean;
  onFechar: () => void;
  onCriado?: () => void;
}

// Etapa de setup MODELO (RN-17) — cria a versão de template que serve de base pros itens definidos
// depois nas etapas TEMPLATES_SLA/EVIDENCIAS_REGRAS. Backend já tinha CRUD completo
// (MaestroTemplateController), só faltava a tela.
const ModalGerenciarModelo: React.FC<ModalGerenciarModeloProps> = ({ aberto, onFechar, onCriado }) => {
  const [versoes, setVersoes] = useState<any[]>([]);
  const [carregando, setCarregando] = useState(true);
  const [nome, setNome] = useState('');
  const [descricao, setDescricao] = useState('');
  const [enviando, setEnviando] = useState(false);

  const carregar = () => {
    setCarregando(true);
    maestroService.listarTemplateVersions().then(setVersoes).catch(() => setVersoes([])).finally(() => setCarregando(false));
  };

  useEffect(() => { if (aberto) carregar(); }, [aberto]);

  const criar = () => {
    if (!nome.trim()) return;
    setEnviando(true);
    maestroService.criarTemplateVersion(nome.trim(), descricao.trim() || undefined)
      .then(() => { setNome(''); setDescricao(''); carregar(); onCriado?.(); })
      .catch((e: any) => dispararAcaoSimulada(e?.response?.data?.message ?? 'Não foi possível criar o modelo.'))
      .finally(() => setEnviando(false));
  };

  return (
    <Dialog open={aberto} onClose={onFechar} maxWidth='sm' fullWidth PaperProps={{ className: 'mc-dialog' }}>
      <DialogTitle>Modelo de Fechamento</DialogTitle>
      <DialogContent>
        <p className='mc-texto-neutro' style={{ marginTop: 0 }}>Versão base do modelo de fechamento — as atividades-modelo (com prazo e regras de evidência) são definidas depois, na etapa seguinte.</p>

        {carregando
          ? <p className='mc-texto-neutro'>Carregando...</p>
          : versoes.length === 0
            ? <p className='mc-texto-neutro'>Nenhuma versão de modelo criada ainda.</p>
            : (
              <table className='mc-logs-table'>
                <thead><tr><th>Nome</th><th>Status</th><th>Criado em</th></tr></thead>
                <tbody>
                  {versoes.map(v => (
                    <tr key={v.id}>
                      <td>{v.nome}{v.descricao ? <><br /><small className='mc-texto-neutro'>{v.descricao}</small></> : null}</td>
                      <td><span className='mc-badge mc-badge--neutro'>{v.status}</span></td>
                      <td>{formatarDataHora(v.criadoEm)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}

        <div className='mc-form-inline' style={{ marginTop: 18 }}>
          <label>Nome do modelo<input type='text' value={nome} onChange={e => setNome(e.target.value)} placeholder='Ex.: Modelo de fechamento padrão 2026' /></label>
          <label>Descrição (opcional)<input type='text' value={descricao} onChange={e => setDescricao(e.target.value)} /></label>
          <button type='button' className='mc-btn mc-btn--primary' disabled={enviando || !nome.trim()} onClick={criar}>
            {enviando ? 'Criando...' : 'Criar versão de modelo'}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ModalGerenciarModelo;
